import React, { useContext, useEffect, useState } from 'react';
import { Course, UserRole } from '../../types/lms.types';
import { getAxiosInstance } from '../../../utils/axiosInstance';
import { NecttosContext } from '../../../context/NecttosContext';
import { formatDate } from '../../utilities';

interface AllContentViewProps {
   courses:any[];
   userRole: UserRole;
   onViewAssignment: (assignment: any, source?: string) => void;
}



const Assignment: React.FC<AllContentViewProps> = ({ courses, userRole, onViewAssignment }) => {
  const [allContent, setAllContent] = useState<any[]>([]);


 const subjectAndCount = courses.map((item) => ({
    subjectId: item.subjectId,
    count : item.count
  }))
  const { collegeId } = useContext(NecttosContext);
  const [assignments, setAssignments] = useState<any[]>([]);

useEffect(() => {
 const loadData = async () => {
  const instance = await getAxiosInstance();
  try{
    let resp 
    if(userRole == 'teacher'){
    resp = await instance.post('/college/lms/all/allDashboardAssignmentsTeachers', { subjectAndCount, collegeId });
   }else if( userRole == 'student'){
    resp = await instance.post('/college/lms/all/allDashboardAssignmentsStudents', {subjectAndCount, collegeId, studentId: 'NST-24CC30EF1B6F-4CA8-A416-0C79605B15DB'})
   }
   if(resp?.data){
    console.log(resp.data.data);
      setAssignments(resp.data.data);
   }
  }catch(err){

  }
 }
 loadData()
},[])
  // const subjectAndCount = courses.map((item) => ({
  //   subjectId: item.subjectId,
  //   count : item.count
  // }))
  const getStatusBadge = (isSubmitted: boolean) => {
  return isSubmitted ? 'text-green-600 font-medium' : 'text-red-500 font-medium';
};


  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <h2 className="text-xl font-semibold">All Content</h2>
        <div className="text-sm text-gray-500">Showing {assignments.length} items</div>
      </div>

      <div className="space-y-4">
        {assignments.map((assignment) => (
          <div
            key={`${assignment.type}-${assignment._id}`}
            className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 p-6 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-2xl">📝</span>
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                      {assignment.title}
                    </h3>
                    <span className="text-xs uppercase tracking-wider text-gray-500 font-medium">
                      {assignment.type}
                    </span>
                  </div>
                </div>

                <p className="text-gray-600 dark:text-gray-400 mb-3">{assignment.description}</p>

                <div className="flex items-center gap-4 text-sm text-gray-500">
                  {assignment.type === 'assignment' && <span>Due: {formatDate(assignment.dueDate)}</span>}
                  
                </div>
              </div>

              <div className="flex flex-col items-end gap-2">
                {assignment.status && (
                  <span className={getStatusBadge(assignment.isSubmitted)}>{assignment.isSubmitted? 'Submitted': 'Pending'}</span>
                )}

                <button className="inline-flex items-center px-3 py-1 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100" onClick={()=> {onViewAssignment(assignment, 'dashboard')}}>
                  View Details
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {assignments.length === 0 && (
        <div className="text-center py-12">
          <span className="text-6xl mb-4 block">📭</span>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No Contents Found</h3>
          <p className="text-gray-500">No contents available for the selected module.</p>
        </div>
      )}
    </div>
  );
};

export default Assignment;
